(function() {
  var SWIPER_SEL = '[data-el-testimonials-swiper]';

  function equalizeSlideHeights(swiper) {
    if (!swiper || !swiper.slides || swiper.slides.length === 0) return;
    var maxH = 0;
    for (var i = 0; i < swiper.slides.length; i++) {
      swiper.slides[i].style.height = '';
      var h = swiper.slides[i].offsetHeight;
      if (h > maxH) maxH = h;
    }
    for (var j = 0; j < swiper.slides.length; j++) {
      swiper.slides[j].style.height = maxH + 'px';
    }
  }

  function initSection(section) {
    var swiperEl = section.querySelector(SWIPER_SEL);
    if (!swiperEl || typeof Swiper === 'undefined') return;

    var nav = section.querySelector('.el-testimonials__nav');
    var prevEl = nav ? nav.querySelector('.swiper-button-prev') : null;
    var nextEl = nav ? nav.querySelector('.swiper-button-next') : null;
    var paginationEl = nav ? nav.querySelector('.swiper-pagination') : null;

    var testimonialsSwiper = new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 16,
      breakpoints: {
        0: { slidesPerView: 1.25, spaceBetween: 12 },
        581: { slidesPerView: 1.5, spaceBetween: 12 },
        981: { slidesPerView: 3, spaceBetween: 16 }
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      },
      pagination: {
        el: paginationEl,
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active'
      },
      on: {
        init: function() {
          requestAnimationFrame(function() { equalizeSlideHeights(testimonialsSwiper); });
        },
        resize: function() {
          requestAnimationFrame(function() { equalizeSlideHeights(testimonialsSwiper); });
        }
      }
    });

    window.addEventListener('resize', function onResize() {
      requestAnimationFrame(function() { equalizeSlideHeights(testimonialsSwiper); });
    });
  }

  function run() {
    document.querySelectorAll('.el-testimonials').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector && e.target.querySelector(SWIPER_SEL)) {
      initSection(e.target);
    }
  });
})();
